var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordViewed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.005,
    height: 20.005,
    viewBox: "0 0 20.005 20.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "password_viewed",
    "data-name": "password viewed",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3312",
    "data-name": "Path 3312",
    d: "M12,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16Z",
    transform: "translate(-1.995 -1.995)",
    fill: "#b2b1ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3313",
    "data-name": "Path 3313",
    d: "M21.919,11.6C19.9,6.914,16.1,4,12,4S4.1,6.914,2.081,11.6a1,1,0,0,0,0,.791C4.1,17.086,7.9,20,12,20s7.9-2.914,9.919-7.6A1,1,0,0,0,21.919,11.6ZM12,16a4,4,0,1,1,4-4A4,4,0,0,1,12,16Z",
    transform: "translate(-1.995 -1.995)",
    fill: "#d8d8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3314",
    "data-name": "Path 3314",
    d: "M21,22a1,1,0,0,1-.707-.293l-18-18A1,1,0,0,1,3.7,2.283l.01.01,18,18A1,1,0,0,1,21,22Z",
    transform: "translate(-1.995 -1.995)",
    fill: "#6563ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordViewed);
export default __webpack_public_path__ + "static/media/passwordViewed.8e12ad357566748330edb9156375d5a1.svg";
export { ForwardRef as ReactComponent };